import React,{useState} from 'react';
import '../../styles/ContractorJobPage.css';

import {collection,addDoc,serverTimestamp} from 'firebase/firestore';
import {db} from '../../firebase/firebase';

const N8N_CONTRACTOR_WEBHOOK_URL="https://nassirmohamoud.app.n8n.cloud/webhook/bc5bf79c-c734-471c-9cee-9d9aaff83826";

function ContractorJobPage(){

  const[loading,setLoading]=useState(false);

  const[formData,setFormData]=useState({
    company:'',
    contact:'',
    email:'',
    phone:'',

    jobTitle:'',
    role:'',
    workersNeeded:'',
    postcode:'',
    location:'',
    pay:'',
    startDate:'',
    duration:'',

    cscs:'',
    drivingLicence:'',
    utr:'',
    tools:'',

    description:'',
    notes:''
  });

  const handleChange=(e)=>{
    setFormData({
      ...formData,
      [e.target.name]:e.target.value
    });
  };

  const resetForm=()=>{
    setFormData({
      company:'',
      contact:'',
      email:'',
      phone:'',

      jobTitle:'',
      role:'',
      workersNeeded:'',
      postcode:'',
      location:'',
      pay:'',
      startDate:'',
      duration:'',

      cscs:'',
      drivingLicence:'',
      utr:'',
      tools:'',

      description:'',
      notes:''
    });
  };

  const handleSubmit=async(e)=>{
    e.preventDefault();

    try{

      setLoading(true);

      const contractorJob={
        ...formData,
        status:'new',
        createdAt:serverTimestamp()
      };

      const docRef=await addDoc(
        collection(
          db,
          "contractorJobs"
        ),
        contractorJob
      );

      console.log("Firestore document created:",docRef.id);

      const response=await fetch(
        N8N_CONTRACTOR_WEBHOOK_URL,
        {
          method:'POST',
          headers:{
            'Content-Type':'application/json'
          },
          body:JSON.stringify({
            id:docRef.id,
            ...formData,
            status:'new'
          })
        }
      );

      if(!response.ok){
        throw new Error(
          `Webhook failed: ${response.status} ${response.statusText}`
        );
      }

      console.log("Webhook sent successfully.");

      alert('Job submitted successfully.');

      resetForm();

    }catch(error){

      console.error("Submission error:",error);

      alert(
        `Failed to submit job.\n\n${error.message}`
      );

    }finally{

      setLoading(false);

    }

  };

  return(
    <div className="contractor-job-page">

      <div className="contractor-job-container">

        <h1>Contractor Job Request</h1>

        <p>
          Complete the form below and AXU Workforce will begin sourcing suitable workers.
        </p>

        <form onSubmit={handleSubmit}>

          <h2>Company Details</h2>

          <input
            type="text"
            name="company"
            placeholder="Company Name"
            value={formData.company}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="contact"
            placeholder="Contact Name"
            value={formData.contact}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <h2>Job Details</h2>

          <input
            type="text"
            name="jobTitle"
            placeholder="Job Title"
            value={formData.jobTitle}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="role"
            placeholder="Role Required"
            value={formData.role}
            onChange={handleChange}
            required
          />

          <input
            type="number"
            name="workersNeeded"
            placeholder="Workers Needed"
            value={formData.workersNeeded}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="postcode"
            placeholder="Postcode"
            value={formData.postcode}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="location"
            placeholder="Location"
            value={formData.location}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="pay"
            placeholder="Pay"
            value={formData.pay}
            onChange={handleChange}
          />

          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
          />

          <input
            type="text"
            name="duration"
            placeholder="Duration"
            value={formData.duration}
            onChange={handleChange}
          />

// ======================================================
// ===== PASTE PART 2 IMMEDIATELY BELOW THIS LINE ========
// ======================================================
<h2>Requirements</h2>

<select
  name="cscs"
  value={formData.cscs}
  onChange={handleChange}
>
  <option value="">CSCS Required?</option>
  <option value="Yes">Yes</option>
  <option value="No">No</option>
</select>

<select
  name="drivingLicence"
  value={formData.drivingLicence}
  onChange={handleChange}
>
  <option value="">Driving Licence Required?</option>
  <option value="Yes">Yes</option>
  <option value="No">No</option>
</select>

<select
  name="utr"
  value={formData.utr}
  onChange={handleChange}
>
  <option value="">UTR Required?</option>
  <option value="Yes">Yes</option>
  <option value="No">No</option>
</select>

<select
  name="tools"
  value={formData.tools}
  onChange={handleChange}
>
  <option value="">Own Tools Required?</option>
  <option value="Yes">Yes</option>
  <option value="No">No</option>
</select>

<h2>Description</h2>

<textarea
  name="description"
  rows="6"
  placeholder="Describe the work..."
  value={formData.description}
  onChange={handleChange}
/>

<textarea
  name="notes"
  rows="4"
  placeholder="Additional notes..."
  value={formData.notes}
  onChange={handleChange}
/>

<button
  type="submit"
  disabled={loading}
>
  {loading ? "Submitting..." : "Submit Job Request"}
</button>

</form>

</div>

</div>
);
}

export default ContractorJobPage;